import { render, staticRenderFns } from "./ObjectAttachments.vue?vue&type=template&id=2a81ec6b&"
import script from "./ObjectAttachments.vue?vue&type=script&lang=js&"
export * from "./ObjectAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports